import React, { useState, useEffect } from 'react'
import { TbX } from 'react-icons/tb'
import { Link } from 'react-router-dom'

const BANNER_HIDE_KEY = 'banner_hidden_timestamp'
const HIDE_DURATION = 30 * 60 * 1000 // 30 minutes in milliseconds

const BannerPromotional = () => {
  const [isVisible, setIsVisible] = useState(true)
  const [isFadingOut, setIsFadingOut] = useState(false)

  useEffect(() => {
    // Check if banner was previously hidden and if 30 minutes have passed
    const hiddenTimestamp = localStorage.getItem(BANNER_HIDE_KEY)
    if (hiddenTimestamp) {
      const timeSinceHidden = Date.now() - parseInt(hiddenTimestamp)
      if (timeSinceHidden < HIDE_DURATION) {
        setIsVisible(false)
        // Set timer to show banner again after remaining time
        const remainingTime = HIDE_DURATION - timeSinceHidden
        const timer = setTimeout(() => {
          setIsVisible(true)
          localStorage.removeItem(BANNER_HIDE_KEY)
        }, remainingTime)
        return () => clearTimeout(timer)
      } else {
        // 30 minutes have passed, clear localStorage
        localStorage.removeItem(BANNER_HIDE_KEY)
      }
    }
  }, [])

  const handleClose = () => {
    setIsFadingOut(true)
    // Store the timestamp when banner is hidden
    localStorage.setItem(BANNER_HIDE_KEY, Date.now().toString())
    
    // After fade-out animation completes, hide the banner
    setTimeout(() => {
      setIsVisible(false)
      setIsFadingOut(false)
      
      // Set timer to show banner again after 30 minutes
      setTimeout(() => {
        setIsVisible(true)
        localStorage.removeItem(BANNER_HIDE_KEY)
      }, HIDE_DURATION)
    }, 300) // 300ms matches the CSS transition duration
  }

  if (!isVisible) return null

  return (
    <div className={`transition-opacity duration-300 ${isFadingOut ? 'opacity-0' : 'opacity-100'}`}>
      <div 
				className="flex items-center justify-center h-9 w-9 bg-orange-700 cursor-pointer hover:bg-orange-800 transition-colors"
				onClick={handleClose}
			>
				<TbX size={20} color="white" />
			</div>

      <Link to="/tienda" className='w-full'>
        <div className="h-[4rem] bg-orange-600 flex items-center justify-between px-4">
          <div className="flex items-center gap-3">
            <div className="text-white">
              <p className="font-semibold text-sm md:text-base">¡Gracias a nuestros benefactores!</p>
              <p className="text-xs md:text-sm text-white/90">El proyecto sigue GRATIS</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 text-white/90 group-hover:text-white transition-colors">
                  <span className="text-xs md:text-sm font-medium">💜 Visitar tienda</span>
                  <svg 
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
      </Link>
    </div>
  )
}

export default BannerPromotional